<form [formGroup]="form">
  <ix-select
    class="half-width"
    formControlName="poolId"
    [label]="'Pool' | translate"
    [options]="poolOptions$"
    [required]="true"
  ></ix-select>
</form>
